import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import emailService from '../services/emailService';

function WhatsAppDetail() {
  const { id } = useParams();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await emailService.getWhatsAppMessage(id);
        setMessage(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) return <div className="p-6">Chargement...</div>;
  if (error) return <div className="p-6 text-red-600">{String(error)}</div>;
  if (!message) return <div className="p-6">Introuvable.</div>;

  return (
    <div className="container mx-auto px-4 py-6">
      <Link to="/whatsapp" className="text-blue-600">← Retour</Link>
      <h1 className="text-2xl font-bold mt-2">{message.conversation}</h1>
      <div className="text-sm text-slate-500">{message.date} — {message.sender}</div>
      <pre className="whitespace-pre-wrap mt-4 p-4 border rounded bg-white">{message.content}</pre>
    </div>
  );
}

export default WhatsAppDetail;


